var domain = window.location.hostname
var baseDomain = ''

// Production is default
switch (domain) {
  case 'localhost':
    baseDomain = 'http://localhost:3000'
    break
  case 'qa.shoponcampus.com':
    baseDomain = 'https://railsapi.dineoncampus.com'
    break
  default:
    baseDomain = 'https://api.shoponcampus.com'
}

export default baseDomain
